module.exports = __webpack_public_path__ + "static/media/snake.869f4b9a.png";